import { registerLegacySalvoLiteComponent } from '@eastsideco/salvo-ts';

class ScrollClasses {
    constructor(theme, elem) {
        this._theme = theme;
        this._elem = elem;
        this._data = {
            breakpoint: 185,
            changeClass: [
                {
                    target: 'body',
                    up: 'page-scrolled-up',
                    down: 'page-scrolled-down'
                }
            ]
        };
        this._lastScrollTop = 0;
    }

    onInit() {
        this.applyScrollClasses();
        window.addEventListener('scroll', () => {
            // eslint-disable-next-line max-len
            if (!document.body.classList.contains('prevent-scroll')) {
                this.applyScrollClasses();
            }
        });
    }

    applyScrollClasses() {
        // Determine scroll distances
        // eslint-disable-next-line max-len
        const distanceFromTop = window.scrollY || window.scrollY || document.body.scrollTop + (document.documentElement && (document.documentElement.scrollTop || 0));
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const { breakpoint, changeClass } = this._data;

        // Check if we've scrolled past the breakpoint
        if (distanceFromTop > breakpoint) {

            // Scrolling down?
            if (scrollTop > this._lastScrollTop) {

                // Update classes for each defined element
                // eslint-disable-next-line ban/ban
                changeClass.forEach((classChange) => {
                    const target = document.querySelector(classChange.target);
                    target.classList.contains(classChange.up) && target.classList.remove(classChange.up);
                    !target.classList.contains(classChange.down) && target.classList.add(classChange.down);
                });

            // Scrolling up?
            } else {

                // Update classes for each defined element
                // eslint-disable-next-line ban/ban
                changeClass.forEach((classChange) => {
                    const target = document.querySelector(classChange.target);
                    !target.classList.contains(classChange.up) && target.classList.add(classChange.up);
                    target.classList.contains(classChange.down) && target.classList.remove(classChange.down);
                });
            }

        // Breakpoint not reached
        } else {

            // Reset classes for each defined element
            // eslint-disable-next-line ban/ban
            changeClass.forEach((classChange) => {
                const target = document.querySelector(classChange.target);
                target.classList.contains(classChange.up) && target.classList.remove(classChange.up);
                target.classList.contains(classChange.down) && target.classList.remove(classChange.down);
            });
        }

        // Fix for mobile negative scrolling
        this._lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
}

export default registerLegacySalvoLiteComponent({
    component: ScrollClasses,
    selector: '[data-scroll-classes]', // Required
});
